import { Component } from 'react';

import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import STYLES from './ProgressiveOriginalImage.module.scss';

import { lowRes } from '@shared/ui/common/img';

type Props = {
  sectionClassName?: string;
  className?: string;
  src: string;
};

type State = {
  heroQuality: string;
};

const defaultProps = {
  sectionClassName: null,
  className: null,
};

const cls = cssModules(STYLES);

class ProgressiveOriginalImage extends Component<Props, State> {
  static defaultProps = defaultProps;

  image: any;

  constructor(props: Props) {
    super(props);
    this.state = {
      heroQuality: 'low',
    };
    this.image = null;
  }

  componentDidMount() {
    const { src } = this.props;
    this.image = new Image();

    this.image.onload = () => {
      this.setState({
        heroQuality: 'high',
      });
    };

    this.image.src = src;
  }

  componentWillUnmount() {
    if (!this.image) {
      return;
    }
    // remove image if image not load completely
    this.image.onload = () => {};
    delete this.image;
  }

  render() {
    const { heroQuality } = this.state;
    const { className, sectionClassName, src } = this.props;

    return (
      <section className={cls('ProgressiveOriginalImage', sectionClassName)}>
        <div
          className={cls(
            className,
            'ProgressiveOriginalImage__img',
            'ProgressiveOriginalImage__lowQuality',
          )}
          style={{
            backgroundImage: `url(${lowRes})`,
            opacity: heroQuality === 'low' ? 1 : 0,
          }}
        />
        <div
          className={cls(className, 'ProgressiveOriginalImage__img')}
          style={{
            backgroundImage: `url(${src})`,
            opacity: heroQuality === 'high' ? 1 : 0,
          }}
        />
      </section>
    );
  }
}

export default ProgressiveOriginalImage;
